import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Svg } from '@/shared/ui/Svg';
import ChevronDownIcon from '@/shared/assets/icons/chevron-down.svg';
import styles from './CourseBreadcrumbs.module.scss';

export interface CourseBreadcrumbItem {
  label: string;
  href?: string;
}

interface CourseBreadcrumbsProps {
  items: CourseBreadcrumbItem[];
}

export const CourseBreadcrumbs = ({ items }: CourseBreadcrumbsProps) => {
  if (!items.length) return null;

  return (
    <nav className={styles.root} aria-label="Breadcrumb">
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const content: ReactNode = item.href ? (
            <Link to={item.href} className={styles.link}>
              <span>
                {' '}
                <Svg className={styles.icon} Icon={ChevronDownIcon} width={36} height={36} />
              </span>
              <span className={styles.label}>{item.label}</span>
            </Link>
          ) : (
            <span className={styles.current}>{item.label}</span>
          );
          return (
            <li key={index} className={styles.item}>
              {isLast && (
                <span className={styles.separator}>
                  <Svg Icon={ChevronDownIcon} width={36} height={36} />
                </span>
              )}
              {content}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
